import { ProjectsOverview } from "@/app/components/projects/ProjectsOverview";

export default function ProjectsPage() {
    return <ProjectsOverview />;
}
